export const IS_ALLOCATING_INVENTORY = {
  key: 'IS_ALLOCATING_INVENTORY',
  initialState: false,
};

export const currentCostReviewTrackingId = (initialTrackingId) => ({
  key: 'CURRENT_COST_REVIEW_TRACKING_ID',
  initialState: initialTrackingId,
});

export const workflowDataState = (initialState) => ({
  key: 'WORKFLOW_DATA',
  initialState,
});

export const cheapestRateState = (fulfillmentPlanId, initialState) => ({
  key: `CHEAPEST_RATE_${fulfillmentPlanId}`,
  initialState,
});

export const freightQuoteState = (fulfillmentPlanId, initialState) => ({
  key: `FREIGHT_QUOTE_${fulfillmentPlanId}`,
  initialState,
});

export const currentFreightQuoteIdState = {
  key: 'CURRENT_FREIGHT_QUOTE_ID',
  initialState: null,
};

const freightQuoteRefCounts = {};
export const __testOnlyClearFreightQuoteRefCounts = () => {
  Object.keys(freightQuoteRefCounts).forEach((k) => delete freightQuoteRefCounts[k]);
};

export const retainFreightQuote = (id, setter) => {
  freightQuoteRefCounts[id] = (freightQuoteRefCounts[id] ?? 0) + 1;
  if (freightQuoteRefCounts[id] === 1) {
    setter(id);
  }
};

export const releaseFreightQuote = (id, setter) => {
  freightQuoteRefCounts[id] = Math.max(0, (freightQuoteRefCounts[id] ?? 0) - 1);
  if (freightQuoteRefCounts[id] === 0) {
    delete freightQuoteRefCounts[id];
    setter(null);
  }
};
